function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9BADBC",
  fillRule: "evenodd",
  d: "M8 16a8 8 0 118-8 8 8 0 01-8 8zm.75-6.667c0 .184-.15.334-.333.334h-.75a.333.333 0 01-.334-.334c0-2.215 1.875-2.006 1.875-3.666 0-.553-.626-1-1.27-1-.645 0-1.282.447-1.282 1-.002.19.027.378.087.558a.332.332 0 01-.313.442h-.677c-.15 0-.283-.1-.323-.245a2.79 2.79 0 01-.097-.755c0-1.289 1.194-2.334 2.667-2.334 1.473 0 2.667 1.045 2.667 2.334 0 2.139-1.917 2.055-1.917 3.666zM8 10.667a1 1 0 11-1 1 1 1 0 011-1z"
});

var SvgQuestionIcon = function SvgQuestionIcon(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgQuestionIcon;